import React from "react";
import styled from '@emotion/styled'
import * as mq from '../../styles/media-queries'

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2000;
  width: calc(100% - 240px);
  height: 100%;
  align-items: center;
  justify-content: center;
  background: ${({ opened = false }) => opened ? "rgba(0, 0, 0, 0.2)" : "rgba(0, 0, 0, 0)"};
  display: ${({ opened = false }) => (opened ? "flex" : "none")};
  ${mq.small} {
    width: 100%;
  }
  > div {
    opacity: ${({ opened = false }) => (opened ? 1 : 0)};
  }
`;

const ModalStyle = styled.div`
  background: white;
  width: ${({width}) => width}; 
  ${mq.small} {
    width: 90%;
  }
  max-height: 90%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: auto;
  border-radius: 6px;
  padding: 15px;
  box-shadow: 0 2px 4px 0 rgba(50, 50, 93, 0.1);
`;

function Modal({ isOpen, width='auto', children }) {
  return (
    <ModalBackground opened={isOpen}>
      <ModalStyle width={width}>{children}</ModalStyle>
    </ModalBackground>
  );
}

export default Modal;